<template>
  <div class="o-employee-grid">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <h2 v-if="content.department" class="o-employee-grid__headline">
            {{ content.department }}
          </h2>
          <ul class="o-employee-grid__tags list-unstyled list-inline">
            <li v-for="(tag, i) in selected" :key="i">
              <tag @click="onRemoveTag(tag)">
                {{ tag.value }}
              </tag>
            </li>
          </ul>
        </div>
        <div class="col-md-6 d-flex justify-content-end">
          <base-dropdown
            v-if="filterOptions && filterOptions.length > 1"
            :title="$t('EmployeeFilterDropdown', 'Filter i kategorier')"
            :options="filterOptions"
            :selected="selected"
            class="-filter"
            @onSelect="onOptionSelected"
            @onClear="onClearFilter"
          />
        </div>
      </div>
      <div
        v-for="(department, i1) in departmentsSelected"
        :key="i1"
        class="row mb-6"
      >
        <div class="col-12 col-lg-3">
          <h3 v-if="$isNotNullOrUndefined(department.headline)" class="o-employee-grid__department-headline">
            {{ department.headline }}
          </h3>
        </div>
        <div class="col-12 col-lg-9">
          <div v-if="department && department.employees" class="o-employee-grid__list">
            <div class="row">
              <div
                v-for="(employee, i2) in department.employees"
                :key="i2"
                :ref="`list_${content.key}`"
                class="col-sm-6 col-lg-4"
              >
                <employeeItem :employee="employee" :placeholder="content.fillerImage" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isLoading" class="row">
        <div class="col-12 col-lg-3">
          <!-- headline -->
        </div>
        <div class="col-12 col-lg-9">
          <div class="row">
            <div class="col-md-4">
              <skeleton-loader layout="card" :aspect-ratio="326/392" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hydrateWhenIdle } from 'vue-lazy-hydration';
import Tag from '@/components/atoms/Tag';
import SkeletonLoader from '@/components/atoms/SkeletonLoader';
import BaseDropdown from '@/components/atoms/BaseDropdown';
import contentMixin from '@/mixins/contentMixin';
import {
  getSpacingTopClass,
  getSpacingBottomClass,
} from '@/utils/spacing-classes.js';

export default {
  name: 'EmployeeGrid',
  components: {
    Tag,
    SkeletonLoader,
    BaseDropdown,
    EmployeeItem: hydrateWhenIdle(() => import('@/components/organisms/EmployeeItem')),
  },
  mixins: [contentMixin],
  data () {
    return {
      isLoading: false,
      selected: [],
      departments: []
    };
  },
  computed: {
    culture () {
      return this.$store.getters['site/getCurrentCulture'];
    },
    filterOptions () {
      return this.departments ? this.departments?.map(department => {
        return {
          value: department.headline,
          key: department.key,
          selected: false
        }
      }) : null;
    },
    departmentsSelected () {
      let selected = this.selected?.length ? this.departments?.filter(department => this.selected?.some(s => s.key === department?.key)) : this.departments;
      return selected?.sort((a, b) => this.sortByValue(a, b))
    }
  },
  async mounted () {
    this.isLoading = true;
    this.departments = this.getDepartments({
      culture: this.culture,
      departments: this.content?.departments
    })
    this.isLoading = false;
  },
  methods: {
    getSpacingTopClass: getSpacingTopClass,
    getSpacingBottomClass: getSpacingBottomClass,
    onOptionSelected (item) {
      if (this.selected?.some(s => s.key === item.key)) {
        this.selected = this.selected?.filter(s => s.key !== item.key);
      } else {
        this.selected?.push(item)
      }
    },
    onRemoveTag (item) {
      this.selected = this.selected?.filter(s => s.key !== item.key);
    },
    onClearFilter () {
      this.selected = [];
    },
    getDepartments (props) {
      let departments = [];
      props?.departments?.forEach(async (department, departmentIndex) => {
        let departmentItem = department?.employees ? await Promise.all(department?.employees?.map(async (employee, employeeIndex) => {
          const guid = employee?.meta?.id;
          let response = await this.$axios.get(`/api/content/${guid}/${props.culture}`, {
            validateStatus: false
          })
          let item = {
            ...response?.data?.result?.body?.content,
            key: response?.data?.result?.meta?.id,
            sortOrder: employeeIndex
          }
          return item;
        })) : undefined;
        departments.push({
          ...department,
          employees: departmentItem,
          selected: false,
          sortOrder: departmentIndex
        });
      });
      return departments;
    },
    sortByValue (a, b) {
      return a.sortOrder - b.sortOrder;
    }
  }
};
</script>
